import React, { SyntheticEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TextInput } from 'components'
import { IconSearch, IconClose } from 'components/Icons'
import { ITicketSelectBranchFilterProps } from 'features/Ticket/TicketSelectBranch'
import { onEnter } from 'helpers/common'

function TicketSelectBranchFilter(
  props: ITicketSelectBranchFilterProps,
): JSX.Element {
  const { t } = useTranslation(['common', 'ticket'])

  const { isLoading, searchParams, setSearchParams } = props

  const q: string = searchParams?.q || ''
  const [search, setSearch] = useState<string>(q)

  const handleChange = (e: SyntheticEvent): void => {
    e.preventDefault()

    const target = e.target as HTMLInputElement

    setSearch(target.value)
  }

  const handleClear = (): void => {
    setSearchParams({ q: '', _page: 1 })
    setSearch('')
  }

  const handleSubmit = (): void => {
    setSearchParams({ q: search.trim(), _page: 1 })
  }

  return (
    <TextInput
      showIcon={isLoading}
      isLoading={isLoading}
      disabled={isLoading}
      placeholder={t('ticket:searchSelectBranchList.placeholder')}
      name='search'
      onChange={handleChange}
      value={search}
      variants='secondary'
      onKeyDown={onEnter(handleSubmit)}
      withIcon={
        q && q === search ? (
          <span
            data-testid='close-ticket'
            className='pointer'
            onClick={handleClear}
          >
            <IconClose variants='sm' />
          </span>
        ) : (
          <span
            data-testid='search-ticket'
            className='pointer'
            onClick={handleSubmit}
          >
            <IconSearch variants='sm' />
          </span>
        )
      }
      fullWidth
    />
  )
}

export default TicketSelectBranchFilter
